import z from "zod";

export type RewriteConfig = z.infer<typeof REWRITE_CONFIG_SCHEMA>;

export const REWRITE_CONFIG_SCHEMA = z.object({
  shop: z.string().optional(),
  "loyalty-blog": z.string().optional(),
  blog: z.string().optional(),
});

export const REWRITE_LOCALE_CONFIG_SCHEMA = z.record(
  z.string(),
  REWRITE_CONFIG_SCHEMA
);

export const prepareRewriteUrls = (envRewriteConfig?: string) => {
  const rewriteUrls = JSON.parse(envRewriteConfig || "{}");
  const rewriteConfig = REWRITE_LOCALE_CONFIG_SCHEMA.safeParse(rewriteUrls);
  const isValidConfig = rewriteConfig.success && rewriteConfig.data;
  if (!isValidConfig) {
    return {};
  }
  return rewriteConfig.data;
};

export const env = {
  builderApiKey: process.env.NEXT_PUBLIC_BUILDER_API_KEY ?? "",
  builderGraphqlEndpoint:
    process.env.NEXT_PUBLIC_BUILDER_GRAPHQL_ENDPOINT ?? "",
  magentoGraphqlEndpoint:
    process.env.NEXT_PUBLIC_MAGENTO_GRAPHQL_ENDPOINT ?? "",
  brand: process.env.NEXT_PUBLIC_BRAND ?? "",
  devDebugFetchCache: process.env.NEXT_PUBLIC_DEV_DEBUG_FETCH_CACHE ?? "",
  fetchCacheEnable: process.env.NEXT_PUBLIC_FETCH_CACHE_ENABLE ?? "",
  siteUrl: process.env.NEXT_PUBLIC_SITE_URL ?? "",
  rewriteUrlsConfig: prepareRewriteUrls(process.env.NEXT_PUBLIC_REWRITE_CONFIG),
  specificUrlsRewriteConfig: prepareRewriteUrls(
    process.env.NEXT_PUBLIC_SPECIFIC_URLS_REWRITE_CONFIG
  ),
  magentoRootCategoryUid: process.env.NEXT_PUBLIC_ROOT_CATEGORY_UID ?? "",
  availableMagentoStores:
    process.env.NEXT_PUBLIC_AVAILABLE_MAGENTO_STORES ?? "",
} as const;
